import { baseUrl, environment } from "../environment";
import {
  AddCandidatePayload,
  ApproveRejectPayload,
  CandidateEditPayload,
  CandidateListAgainstStatusPayload,
  CheckActionStatusPayload,
  EmployeeAllDetailsPayload,
  EmployeeAllPayload,
  EmployeeEditPayload,
  EventStatusPayload,
  GetAllOrgsForReportingManagerPayload,
  GetAllReportingManagersPayload,
  GetSalaryDetailsForApprovalPayload,
  IEmployeeLocationPayload,
  IEmployeeLocationsCreatePayload,
  ReportingManagerGetPayload,
  ReportingManagerPayload,
  SalaryDetailsGivenForWaitingCandPayload,
  SendOfferMailToCandidatePayload,
  UserCreationFromOnbardongPayload,
  ViewEmployee,
  EmployeeTransferPayload,
} from "../models/employeeModel";
import RestService from "./rest";

export const serviceClient = new RestService({
  baseURL: baseUrl,
});

export const AddCandidateService = (data: AddCandidatePayload) => {
  return serviceClient.post(environment.urls.AddCandidate, data);
};
export const GetAllEventStausService = (data: any) => {
  let url = environment.urls.getEventcheckStatus;
  const params: string[] = [];
  if (data?.sort_by) {
    params.push(`sort_by=${data?.sort_by}`);
  }
  if (data?.sort_order) {
    params.push(`sort_order=${data?.sort_order}`);
  }
  if (params.length > 0) {
    url = `${url}?${params.join("&")}`;
  }
  return serviceClient.post(url, data);
};
export const GetAllRefferalService = (data: any) => {
  let url = environment.urls.getRefferal;
  const params: string[] = [];
  if (data?.sort_by) {
    params.push(`sort_by=${data?.sort_by}`);
  }
  if (data?.sort_order) {
    params.push(`sort_order=${data?.sort_order}`);
  }
  if (params.length > 0) {
    url = `${url}?${params.join("&")}`;
  }
  return serviceClient.post(url, data);
};
export const GetEmployeeViewService = (data: ViewEmployee) => {
  return serviceClient.post(environment.urls.getEmployeeView, data);
};

export const ReportingManagerGet = (data: ReportingManagerGetPayload) => {
  return serviceClient.post(environment.urls.reportingmanagerGetUrl, data);
};

export const ForceLogoutOrganizationService = (data: {
  organization_ids: number[];
  include_child_orgs: boolean;
  password: string;
}) => {
  return serviceClient.post(environment.urls.forceLogoutOrganization, data);
};

export const EmployeeByOrgWithParentsService = (data: {
  organization_id?: number;
  searchText?: string;
  pageIndex?: number;
  pageSize?: number;
}) => {
  return serviceClient.post(environment.urls.employeeByOrgWithParents, data);
};
export const GetAllOrgsForReportingManagerService = (
  data: GetAllOrgsForReportingManagerPayload,
) => {
  return serviceClient.post(
    environment.urls.getAllOrgsForReportingManager,
    data,
  );
};
export const GetAllReportingManagersService = (
  data: GetAllReportingManagersPayload,
) => {
  return serviceClient.post(environment.urls.getAllReportingManagers, data);
};
export const CandidateApproveReject = (data: ApproveRejectPayload) => {
  return serviceClient.post(environment.urls.candidateApproveUrl, data);
};

export const GetAllCandidateService = (data: any) => {
  let url = environment.urls.getAllCandidate;
  const params: string[] = [];
  if (data?.sort_by) {
    params.push(`sort_by=${data?.sort_by}`);
  }
  if (data?.sort_order) {
    params.push(`sort_order=${data?.sort_order}`);
  }
  if (params.length > 0) {
    url = `${url}?${params.join("&")}`;
  }
  return serviceClient.post(url, data);
};
export const GetAllEmployeeService = (data: EmployeeAllPayload) => {
  let url = environment.urls.getAllEmployee;
  const params: string[] = [];
  if (data?.sort_by) {
    params.push(`sort_by=${data?.sort_by}`);
  }
  if (data?.sort_order) {
    params.push(`sort_order=${data?.sort_order}`);
  }
  if (params.length > 0) {
    url = `${url}?${params.join("&")}`;
  }
  return serviceClient.post(url, data);
};
export const CheckActionStatus = (data: CheckActionStatusPayload) => {
  return serviceClient.post(environment.urls.actionStatusUrl, data);
};
export const GetEmployeeAllDetailsService = (
  data: EmployeeAllDetailsPayload,
) => {
  return serviceClient.post(environment.urls.getEmployeeAllDetails, data);
};
export const GetAllBankListService = () => {
  return serviceClient.get(environment.urls.getAllBankList);
};
export const CandidateEditService = (data: CandidateEditPayload) => {
  return serviceClient.post(environment.urls.editEmployee, data);
};
export const GetAllBulkUploadCandiidateListService = () => {
  return serviceClient.get(environment.urls.getBulkUploadCandidate);
};

export const getBulkUploadCandidate = () => {
  return serviceClient.get(`${environment.urls.getBulkUploadCandidate}`);
};

export const getBulkUploadCandidateUpdated = (bulkIds: number[]) => {
  return serviceClient.post(`${environment.urls.getFilteredBulkStatus}`, {
    bulkIds,
  });
};

export const GetCandidateBulkCreateListService = (
  page_index?: number,
  page_size?: number,
  sort_by?: string | null,
  sort_order?: "asc" | "desc" | null,
) => {
  const params: string[] = [];
  if (page_index !== undefined && page_size !== undefined) {
    params.push(`page_index=${page_index}`);
    params.push(`page_size=${page_size}`);
  }
  if (sort_by) {
    params.push(`sort_by=${sort_by}`);
  }
  if (sort_order) {
    params.push(`sort_order=${sort_order}`);
  }
  const query = params.length > 0 ? `?${params.join("&")}` : "";
  return serviceClient.get(
    `${environment.urls.candidateBulkCreateList}${query}`,
  );
};

export const GetCandidateBulkCreateStatusService = (
  uploadId: number | string,
) => {
  return serviceClient.get(
    `${environment.urls.candidateBulkCreateStatus}${uploadId}`,
    {
      responseType: "blob",
    },
  );
};

export const EmployeeEditService = (data: EmployeeEditPayload) => {
  return serviceClient.post(environment.urls.editEmployeeDashboard, data);
};

export const resetpasswordrequestService = (employeeId: string) => {
  return serviceClient.post(environment.urls.resetpasswordrequest, {
    employee_id: employeeId,
  });
};
export const EmployeeTransferService = (data: EmployeeTransferPayload) => {
  return serviceClient.post(environment.urls.employeeTransfer, data);
};
export const UpdateEmployeeActiveInactiveService = (data: {
  employee_id: string;
  status: "ACTIVE" | "INACTIVE";
}) => {
  return serviceClient.post(environment.urls.activeInactiveEmployee, data);
};
export const GetEmployeeTransferRequestsService = (
  pageIndex?: number,
  pageSize?: number,
  filters?: {
    employee_id?: string | null;
    employee_name?: string | null;
    current_organization_id?: number | null;
    new_organization_id?: number | null;
    status?: number | null;
  },
  searchText?: string,
) => {
  const params: string[] = [];
  if (pageIndex !== undefined) {
    params.push(`pageIndex=${pageIndex}`);
  }
  if (pageSize !== undefined) {
    params.push(`pageSize=${pageSize}`);
  }
  if (filters?.employee_id) {
    params.push(`employee_id=${encodeURIComponent(filters.employee_id)}`);
  }
  if (filters?.employee_name) {
    params.push(`employee_name=${encodeURIComponent(filters.employee_name)}`);
  }
  if (filters?.current_organization_id) {
    params.push(`current_organization_id=${filters.current_organization_id}`);
  }
  if (filters?.new_organization_id) {
    params.push(`new_organization_id=${filters.new_organization_id}`);
  }
  if (filters?.status !== undefined && filters?.status !== null) {
    params.push(`status=${filters.status}`);
  }
  if (searchText?.trim()) {
    params.push(`searchText=${encodeURIComponent(searchText.trim())}`);
  }
  const query = params.length > 0 ? `?${params.join("&")}` : "";
  return serviceClient.get(`${environment.urls.employeeTransferRequests}${query}`);
};
export const ReportingManagerEditService = (data: ReportingManagerPayload) => {
  return serviceClient.post(environment.urls.editReportingManager, data);
};

export const GetMyTeamService = (
  sort_by?: string | null,
  sort_order?: "asc" | "desc" | null,
) => {
  const params: string[] = [];
  if (sort_by) {
    params.push(`sort_by=${sort_by}`);
  }
  if (sort_order) {
    params.push(`sort_order=${sort_order}`);
  }
  const query = params.length > 0 ? `?${params.join("&")}` : "";
  return serviceClient.get(`${environment.urls.getMyTeamList}${query}`);
};

export const GetEmployeeLocationsService = (data: IEmployeeLocationPayload) => {
  return serviceClient.post(environment.urls.getEmployeeLocations, data);
};

export const CreateEmployeeLocationService = (
  data: IEmployeeLocationsCreatePayload,
) => {
  return serviceClient.post(environment.urls.createEmployeeLocation, data);
};

export const DeleteEmployeeLocationService = (
  data: IEmployeeLocationPayload,
) => {
  return serviceClient.post(environment.urls.deleteEmployeeLocation, data);
};

export const AddEmployeeImagesService = (data: any) => {
  return serviceClient.post(environment.urls.addEmployeeImages, data);
};

export const GetEmployeeImagesService = (data: any) => {
  return serviceClient.post(environment.urls.getEmployeeImages, data);
};

export const DeleteEmployeeImagesService = (data: any) => {
  return serviceClient.post(environment.urls.deleteEmployeeImages, data);
};

export const GetMyDocumentService = (employeeId: any) => {
  return serviceClient.get(`${environment.urls.getMyDocument}/${employeeId}`);
};

export const DeleteMyDocumentService = (id: any) => {
  return serviceClient.delete(`${environment.urls.deleteMyDocument}/${id}`);
};

export const ChangeReportingManagerService = (data: any) => {
  return serviceClient.post(environment.urls.changeReportingManager, data);
};

export const ChangeDesignationService = (data: any) => {
  return serviceClient.post(environment.urls.changeDesignation, data);
};

export const ChangeEmployeeTypeService = (data: any) => {
  return serviceClient.post(environment.urls.changeEmployeeType, data);
};

export const UpdateSingleEmpSalaryService = (data: any) => {
  return serviceClient.post(environment.urls.updateSingleEmpSalary, data);
};
export const CalculateSingleEmpSalaryService = (data: any) => {
  return serviceClient.post(environment.urls.calculateEmpSalary, data);
};
export const CandidateListAgainstStatusService = (
  data: CandidateListAgainstStatusPayload,
) => {
  return serviceClient.post(environment.urls.candidateListAgainstStatus, data);
};
export const SalaryGivenForCandidateService = (
  data: SalaryDetailsGivenForWaitingCandPayload,
) => {
  return serviceClient.post(
    environment.urls.salaryDetailsGivenForWaitingCandidate,
    data,
  );
};

export const SendOfferMailToCandidateService = (
  data: SendOfferMailToCandidatePayload,
) => {
  return serviceClient.post(environment.urls.SendOfferMailToCandidate, data);
};
export const GetSalaryDetailsForApprovalService = (
  data: GetSalaryDetailsForApprovalPayload,
) => {
  return serviceClient.post(environment.urls.GetSalaryDetailsForApproval, data);
};
export const UserCreationFromOnboardingService = (
  data: UserCreationFromOnbardongPayload,
) => {
  return serviceClient.post(environment.urls.userCreationFromOnboarding, data);
};
export const getAllTermConditionService = (payload: any) => {
  return serviceClient.get(
    environment.urls.getAllTermCondition + "/" + payload,
  );
};
export const UpdateAttendancePlatformService = (payload: any) => {
  return serviceClient.post(environment.urls.updateAttendancePlatform, payload);
};
export const UpdateAutoAttendanceService = (payload: any) => {
  return serviceClient.post(environment.urls.updateAutoAttendance, payload);
};
export const UpdateAttenFromAnyLocationService = (payload: any) => {
  return serviceClient.post(environment.urls.updateAttenFromAnyLocation, payload);
};

export const searchNameService = (searchQuery: string, type?: string) => {
  return serviceClient.get(
    `${environment.urls.employeeSearchByName}/?search=${searchQuery}&type=${
      type ? type : ""
    }`
  );
};
